module.exports = __webpack_public_path__ + "chrome.png?3d47398ce2cdc24a9220e903d5823c2e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point/chrome.png
// module id = 936
// module chunks = 0